import { translateError as translateErrorHelper } from "./translateError.helper";

export const handleErrors = (
  errors: Array<string> | undefined,
  translateError = true,
  errorDetailsMessage?: string | null,
) => {
  if (errors instanceof Array) {
    if (errors.length > 0) {
      // Generic failures prefer the upstream message (e.g. from SAP) when one is supplied
      if (
        translateError &&
        errors[0] === "INTERNAL_ERROR" &&
        errorDetailsMessage?.trim()
      )
        return errorDetailsMessage;

      // @ts-expect-error: TODO: This new error showed up after updating @vue/tsconfig. Examine if this is really an issue (or `?` or `!` can be applied easily)
      return translateError ? translateErrorHelper(errors[0]) : errors[0];
    }
  }
  return undefined;
};
